<script>
import baseEdit from '@/views/components/base/baseEdit.vue'
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: 'feedback',
      key: 'id',
      url: {
        get: '/admin/system/feedback',
        add: '/admin/system/feedback',
        edit: '/admin/system/feedback',
      },
      items: [
        { label: '基本信息', desc: '表单的基本信息', type: 'header' },
        { label: '反馈内容', name: 'content', value: '', type: 'textarea',width:'400px', rules: [{ required: true, trigger: 'blur' }] },
        { label: '图片', name: 'imgUrl', value: '', type: 'gallery', desc: '图片尺寸最低750*420像素比例', rules: [{ required: true, trigger: 'blur' }] },
        { label: '知识库类别', name: 'type', value: '', type: 'select', dropList: [
          {
            value:1,
            name:'投诉'
          },
          {
            value:2,
            name:'建议'
          },
          {
            value:3,
            name:'其他'
          },
        ] },
     ],
      forms: {},
    }
  },
  created() {
  },
  methods: {
  
  },
}
</script>
